// Scale factor for high-quality PNG export (2x for retina-quality)
const SCALE_FACTOR = 2;

export const convertSvgToCanvas = (
  svgUrl: string,
  canvasWidth: number,
  canvasHeight: number,
): Promise<HTMLCanvasElement> => {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      const canvas = createCanvas(canvasWidth, canvasHeight);
      const ctx = getCanvasContext(canvas);

      if (!ctx) {
        reject(new Error("Failed to get canvas context"));
        URL.revokeObjectURL(svgUrl);
        return;
      }

      drawImageToCanvas(ctx, img, canvasWidth, canvasHeight);
      resolve(canvas);
    };

    img.onerror = () => {
      reject(new Error("Failed to load SVG image"));
      URL.revokeObjectURL(svgUrl);
    };

    img.src = svgUrl;
  });
};

const createCanvas = (canvasWidth: number, canvasHeight: number): HTMLCanvasElement => {
  const canvas = document.createElement("canvas");
  // Increase canvas resolution for high-quality export
  canvas.width = canvasWidth * SCALE_FACTOR;
  canvas.height = canvasHeight * SCALE_FACTOR;
  return canvas;
};

const getCanvasContext = (canvas: HTMLCanvasElement): CanvasRenderingContext2D | null => {
  const ctx = canvas.getContext("2d");
  if (ctx) {
    // Scale context to match the increased resolution
    ctx.scale(SCALE_FACTOR, SCALE_FACTOR);
  }
  return ctx;
};

const drawImageToCanvas = (
  ctx: CanvasRenderingContext2D,
  img: HTMLImageElement,
  canvasWidth: number,
  canvasHeight: number,
): void => {
  ctx.fillStyle = "white";
  ctx.fillRect(0, 0, canvasWidth, canvasHeight);
  ctx.drawImage(img, 0, 0, canvasWidth, canvasHeight);
};
